import { PAYPAL_CLIENT_ID } from './app-common';
import { IS_STRIPE } from './stripe';

export enum PaymentTab {
  CARD = 'CARD',
  PAYPAL = 'PAYPAL',
}

export const PaymentTabLabel = {
  [PaymentTab.CARD]: 'Credit/Debit Card',
  [PaymentTab.PAYPAL]: 'PayPal',
};

export enum PaymentType {
  MESHULAM = 'meshulam',
  PAYPAL = 'paypal',
  STRIPE = 'stripe',
}

export const DEFAULT_PAYMENT_TAB =
  PAYPAL_CLIENT_ID && !IS_STRIPE ? PaymentTab.PAYPAL : PaymentTab.CARD;
